export enum MenuMode {
  static,
  overlay,
  slim,
}
